import { Component } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent {
  constructor(
    public modalCtrl: ModalController,
    private navCtrl: NavController,
  ) {}

  /**
   * Redirect to agreement or search workers page.
   *
   */
  redirect() {
    this.modalCtrl.dismiss();
    this.navCtrl.navigateForward('/client-account');
  }
}
